import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from 'components/core/Button/Button'
import Icon from 'components/core/Icon/Icon'
import Layout from 'components/core/Layout/Layout'
import Modal from 'components/interface/Modal/Modal'
import { useModalContext } from 'components/interface/Modal/provider/ModalProvider'

const label = `We're putting the finishing touches on this feature, so stay tuned
for the upcoming upgrade!`

/**
 * The `ModalMarketplaceLocked` handles the rendering of
 * the sign up modal
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function ModalMarketplaceLocked (props) {
  const { includeCreateLink } = props
  const { onAction } = useModalContext()
  const navigate = useNavigate()

  const title = useMemo(() => <h1>Unlocking Soon!</h1>, [])

  const options = useMemo(
    () => (
      <>
        <li>
          <Button size="large" color="b" onClick={() => onAction('close')}>
            Close
          </Button>
        </li>
        {includeCreateLink && (
          <li>
            <Button
              size="large"
              color="a"
              onClick={() => {
                onAction('close')
                navigate('/create')
              }}
            >
              Create Avatar
            </Button>
          </li>
        )}
      </>
    ),
    []
  )

  return (
    <Modal.Container size="x-small">
      <Modal.Media size="small">
        <Icon icon="lock" />
      </Modal.Media>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <Layout.Body align="center">
          <p style={{ textAlign: 'center' }}>{label}</p>
        </Layout.Body>
      </Modal.Body>
      <Modal.Footer options={[]}>{options}</Modal.Footer>
    </Modal.Container>
  )
}

/** @type {object} */
ModalMarketplaceLocked.propTypes = {
  includeCreateLink: PropTypes.bool
}

/** @type {object} */
ModalMarketplaceLocked.defaultProps = {
  includeCreateLink: true
}

// Memoize
export default memo(ModalMarketplaceLocked)
